import { clone } from 'underscore';
import Backbone from 'backbone';
import React, { useEffect, useRef, useMemo } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import EditorView from '@bingads-webui-campaign-legacy/editorial-appeal/view/editor';
import '@bingads-webui-campaign/ko-stop-binding';
import { getRequestFormStyle } from './style';

export const LegacyEditorialAppealRequestForm = React.memo(({
  id, className, appealTitle, infoMsg, appealData, appealIds, onChange,
}) => {
  const view = useRef();
  const viewListener = useMemo(() => clone(Backbone.Events), []);
  let container;

  useEffect(() => {
    view.current = new EditorView({
      appealData,
      appealTitle,
      infoMsg,
      hideAppealCheckBox: true,
      isForVNext: true,
      withRealTimeUpdates: true,
    });

    viewListener.listenTo(view.current, 'change', onChange);

    view.current.render();
    view.current.$el.appendTo(container);

    view.current.toBulk(appealIds);

    return () => {
      viewListener.stopListening(view.current);
      view.current.remove();
    };
  }, [appealTitle, container, appealData, appealIds, infoMsg, viewListener, onChange]);

  const classes = useDefaultStyles(getRequestFormStyle);

  return (
    <div
      id={id}
      className={classnames(className, classes.requestFormContainer)}
    >
      <div ref={(ref) => { container = ref; }} />
    </div>
  );
});

LegacyEditorialAppealRequestForm.propTypes = {
  id: PropTypes.string,
  className: PropTypes.string,
  appealData: PropTypes.shape({}).isRequired,
  appealIds: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.number, PropTypes.string])).isRequired,
  appealTitle: PropTypes.string.isRequired,
  infoMsg: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};

LegacyEditorialAppealRequestForm.defaultProps = {
  id: undefined,
  className: undefined,
  infoMsg: undefined,
};
